export const iconFontAwesomeEditingCheck = (
	<i className="fa-solid fa-check"></i>
);
